<div class="grid grid-nogutter p-3" [formGroup]="form">
  <div class="col-12 p-fluid p-2">
    <p-autoComplete
      #ownerInput
      [formControlName]="'email'"
      [placeholder]="'feature.user.project.search_or_invite_owners'| translate"
      [delay]="0"
      [suggestions]="usersQueryDPS.resources"
      (completeMethod)="searchUsers($event)"
      [optionLabel]="getAutocompleteOptionLabel"
      [optionValue]="getAutocompleteOptionValue"
      [inputId]="'userQueryInput'"
      [forceSelection]="false"
      [completeOnFocus]="false"
      [autofocus]="false"
      [showClear]="true"
      [appendTo]="'body'"
    >
      <ng-template pTemplate="empty">
        <p>{{'common.no_results'|translate}}</p>
        <small>{{'help.value_should_be_a_valid_email'|translate}}</small>
      </ng-template>
    </p-autoComplete>
    <div *ngIf="form.get('email').invalid && form.get('email').touched"
         class="app-form-error">
      <p>{{ form.get('email')['errorMessage'] }}</p>
      <p *ngIf="form.get('email').errors?.custom">{{ form.get('email').errors?.custom }}</p>
    </div>
  </div>
  <div class="col-12 md:col-6 p-2">
    <div class="width-100 p-fluid p-float-label p-input-icon-left">
      <p-calendar
        [formControlName]="'from'"
        [showIcon]="true"
        inputId="ownerFrom"
        icon="pi pi-calendar"
        dateFormat="dd.mm.yy"
        [appendTo]="'body'"
      />
      <label for="ownerFrom">{{ 'feature.user.project.owner_from' | translate }}</label>
      <div *ngIf="form.get('from').invalid && form.get('from').touched"
           class="app-form-error">
        <p>{{ form.get('from')['errorMessage'] }}</p>
        <p *ngIf="form.get('from').errors?.custom">{{ form.get('from').errors?.custom }}</p>
      </div>
    </div>
  </div>
  <div class="col-12 md:col-6 p-2">
    <div class="width-100 flex justify-content-center align-items-center mb-2">
      <p-inputOtp [formControlName]="'pin'" [integerOnly]="true" [length]="6" />
    </div>
    <div *ngIf="form.get('pin').invalid && form.get('pin').touched"
         class="app-form-error">
      <p>{{ form.get('pin')['errorMessage'] }}</p>
      <p *ngIf="form.get('pin').errors?.custom">{{ form.get('pin').errors?.custom }}</p>
    </div>
    <small>{{'shared.modal.component.change_main_owner.otp.help'|translate }}</small>
  </div>
</div>



